import * as React from "react";

import {FComponent} from "@Common/react/f-component";

interface S {
    show: boolean;
}
interface P {
    delay: number;
    next: () => JSX.Element;
}

export class DelayRender extends FComponent<P, S> {
    constructor(props, context) {
        super(props, context);

        if (props.delay) {
            this.state = {
                show: false,
            };

            setTimeout(() => {
                this.setState({show: true});
            }, props.delay);
        } else {
            this.state = {
                show: true,
            };
        }
    }

    render() {
        const {next} = this.props;
        const {show} = this.state;

        return show && next();
    }
}
